var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0002 0C6.46895 0 3.60645 2.85938 3.60645 6.39063C3.60645 9.92188 10.0002 18.3563 10.0002 18.3563C10.0002 18.3563 16.3908 9.92188 16.3908 6.39063C16.3908 2.85938 13.5314 0 10.0002 0ZM10.0002 10.6219C7.6627 10.6219 5.76895 8.72813 5.76895 6.39063C5.76895 4.05313 7.6627 2.15938 10.0002 2.15938C12.3377 2.15938 14.2314 4.05313 14.2314 6.39063C14.2314 8.72813 12.3377 10.6219 10.0002 10.6219Z",
    fill: "#E82327"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSvg);
export default __webpack_public_path__ + "static/media/LocationSVG.26cef11565caf9c65b081e5df6f612a1.svg";
export { ForwardRef as ReactComponent };